/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$('.Popover__Value').click(function(){
        var totalPacks = $("#compo-product-variant-custom-field").data('totalpacks');        
        var textValueFromDropdown = $(this).data('value');
        var output = renderCompoQuantityHtml(textValueFromDropdown, totalPacks);
        $("#compo-product-variant-custom-field").html(output);
    });
	
// 	var output = renderCompoQuantityHtml($(this).val(), totalPacks);
    var totalPacks = $("#compo-product-variant-custom-field").data('totalpacks');
//     var withPowder = $("#SingleOptionSelector-0").find(':selected').data('powder');
//     var output = renderCompoQuantityHtml($("").val(),totalPacks,withPowder);
 var textValueFromDropdown = $('.ProductForm__SelectedValue').text();
        var output = renderCompoQuantityHtml(textValueFromDropdown, totalPacks);
    $("#compo-product-variant-custom-field").each(function() {
        $("#compo-product-variant-custom-field").html(output);
    });
 
function renderCompoQuantityHtml(textValue,totalPacks,withPowder) {
  console.log(textValue);
  console.log(totalPacks);
  
        window.totalPacks = totalPacks;
  		var changedValue = textValue;
  		var elements = changedValue.split("+");          		
        var htmlToRender = '';
        htmlToRender += `<div class="row">`;
        var scriptToLoad = `<script>
                jQuery(document).ready(function($){
                    $('body').find('.compo-variant-counter-holder a').on('click', function(e){
                        e.preventDefault();
                        $('.compo-variant-counter-holder').removeClass('active');
                        $(this).parent().addClass('active');
                        var currentInActiveVal = parseInt($('.compo-variant-counter-holder').not('.active').find(".variant-qty").val());
                        var currentActiveVal = parseInt($(this).parent().find(".variant-qty").val());
                        if($(this).data('action') == 'minus' && currentActiveVal > 1){
                            var newActiveVal = currentActiveVal - 1;
                            $(this).parent().find(".variant-qty").val(newActiveVal);
                            $('.compo-variant-counter-holder').not('.active').find(".variant-qty").val(currentInActiveVal+1);
                        }else if($(this).data('action') == 'plus' && currentActiveVal < (totalPacks-1)){
                            var newActiveVal = currentActiveVal + 1;
                            $(this).parent().find(".variant-qty").val(newActiveVal);
                            $('.compo-variant-counter-holder').not('.active').find(".variant-qty").val(currentInActiveVal-1);
                        }
                    });
                });
                </script>`;

        if(elements.length > 1){
            for(var i = 0; i < (elements.length); i++){
                if(i==0){
                    var initVal = Math.ceil(totalPacks/2);
                }else{
                    var initVal = Math.floor(totalPacks/2);
                }
                var newItem = `<div class="line-item-property__field">
                                 <label>${elements[i]} ${window.languages.productFormQuantity}</label><br>
                                <div class="compo-variant-counter-holder">
                                    <a data-action="minus" href="#">-</a>
                                    <input required class="variant-qty required" id="${elements[i]}" type="text" value=${initVal} size='1' name="properties[${elements[i]}]">
                                    <a data-action="plus" href="#">+</a>
                                </div>
                                </div>`;
             
                htmlToRender += newItem;
            }
        }

        htmlToRender += `</div>`;

        if(withPowder == 1){
            htmlToRender += `<div class="selector-wrapper powder-flavour-radios">
                    <p class="line-item-property__field">
                        <span class="variant-title">Keto Powder Flavour</span><br>
                        <label class="radio">
                        <input required class="required" type="radio" checked="checked" name="properties[Keto Powder Flavour]" value="Unflavored"> <span>Unflavored</span><br>
                        </label>
                        <label class="radio">
                        <input required class="required" type="radio" name="properties[Keto Powder Flavour]" value="Chocolate"> <span>Chocolate</span><br>
                        </label>
                    </p>
                  </div>`;
        }
        
        return (scriptToLoad + htmlToRender);
    };

